module.exports = ".p-multiselect-item\r\n{\r\n    color:#000 !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/reports-dashboard/custom-reports/custom-reports.component.css
// module id = ./src/app/admin/reports-dashboard/custom-reports/custom-reports.component.css
// module chunks = main